import { AxiosRequestConfig } from 'axios';
import { APP_HEADERS } from '@/utils/constants';

export const fileUploadUrl = `${process.env.REACT_APP_FILE_UPLOAD_URL}/api/file-processes/generate-url`;

export function createFile(
  uploadFile: File,
  token?: string,
): AxiosRequestConfig {
  const formData = new FormData();
  formData.append('file', uploadFile);

  return {
    method: 'POST',
    url: fileUploadUrl,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
      ...APP_HEADERS,
    },
    data: formData,
  };
}
